import Vue from 'vue';
import VueI18Next from '@panter/vue-i18next';
import i18next from 'i18next';
import en from '@/locales/en.json';
import de from '@/locales/de.json';
import fr from '@/locales/fr.json';
import it from '@/locales/it.json';
import { isProduction } from '@/utils/functions';

Vue.use(VueI18Next);

i18next.init({
  lng: 'en',
  fallbackLng: 'de',
  resources: {
    en: { translation: en },
    de: { translation: de },
    fr: { translation: fr },
    it: { translation: it },
  },
  debug: !isProduction(),
});

const i18n = new VueI18Next(i18next);
export default i18n;
